export default "__VITE_ASSET__c56217d4__"